import styled, { css } from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'
import { Identity } from './Identity'

export const ExistingUserFormFields = styled.div`
  width: 100%;

  ${plume.Button} {
    display: none;
  }
`

export const ExistingUserFormBlock = styled.div`
  align-items: baseline;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  ${plume.Link} {
    font-size: 13px; // HACK: Irregular font manipulation
  }
`

export const ExistingUserForm = styled.form`
  align-items: center;
  display: flex;
  flex-direction: column;

  ${plume.styles.copy.M} {
    width: 100%;
    margin: 0 0 11px;
  }

  ${plume.TextField}, ${plume.CheckboxField} {
    margin: 0 0 20px;
  }

  ${plume.TextField}, ${ExistingUserFormBlock} {
    width: 100%;
  }

  ${plume.Button} {
    margin: 0 0 10px;
    width: 100%;
  }

  ${plume.styles.copy.XS} {
    color: ${plume.COLORS.GREY_SHADE_3};
    text-transform: uppercase;
  }
`

export const ThirdPartyAuthExistingUserForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${plume.styles.copy.M} {
    width: 100%;
    margin: 0 0 11px;
  }

  ${plume.TextField} {
    width: 100%;
    position: relative;
  }

  ${plume.Link} {
    position: absolute;
    top: 0;
    right: 0;
  }

  ${plume.SocialButton} {
    margin: 30px 0 10px;
  }

  ${plume.Callout} {
    margin: 0 0 10px;
  }
`

export const ThirdPartyAuthKnownUserForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${Identity} {
    width: 100%;
    padding: 20px 0;
  }

  ${plume.SocialButton} {
    margin: 0 0 10px;
  }
`

export const IdentityBlock = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  ${plume.Link} {
    font-size: 13px; // HACK: Irregular font manipulation
  }
`

export const IdentityGroup = styled.div`
  align-items: baseline;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-start;
  margin-left: 18px;

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    flex-direction: row;
  }

  @media screen and ${plume.BREAKPOINTS.LAPTOP} {
    flex-direction: column;
    margin-left: 18px;
  }
`

export const IdentitySmallText = styled(plume.styles.copy.S)`
  margin: 0;
`

export const IdentityUsernameWrapper = styled(plume.styles.copy.Base)`
  font-size: 17px; // HACK: Irregular font manipulation
  line-height: 22px;
`

export const KnownUserBlock = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;

  ${plume.Link} {
    font-size: 13px;
  }
`

export const NewUserForm = styled.form`
  align-items: center;
  display: flex;
  flex-direction: column;

  ${plume.styles.copy.M} {
    margin: 0 0 11px;
  }

  ${plume.TextField}, ${plume.PasswordField}, ${plume.CheckboxField} {
    margin: 0 0 20px;
  }

  ${plume.TextField}, ${plume.PasswordField} {
    width: 100%;
  }

  ${plume.CheckboxField} {
    ${plume.styles.field.Title} {
      color: ${plume.COLORS.GREY_SHADE_3};
    }
  }

  ${plume.styles.button.CallToAction} {
    margin: 0 0 10px;
  }

  ${plume.styles.copy.XS} {
    color: ${plume.COLORS.GREY_SHADE_3};
    margin: 10px 0 20px;
    text-transform: uppercase;
  }

  ${plume.SocialButton}+${plume.SocialButton} {
    margin-top: 20px;
  }
`

export const UluleKnownUserForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${plume.TextField} {
    &::placeholder {
      color: transparent;
    }
  }

  ${plume.TextField}, ${KnownUserBlock} {
    margin: 0 0 20px;
  }

  ${plume.TextField}, ${KnownUserBlock}, ${Identity} {
    width: 100%;
  }

  ${Identity} {
    margin-bottom: 20px;
  }

  ${plume.Button} {
    margin: 0 0 10px;
  }

  ${plume.styles.copy.XS} {
    color: ${plume.COLORS.GREY_SHADE_3};
    text-transform: uppercase;
  }

  ${plume.SocialButton}+${plume.SocialButton} {
    margin-top: 20px;
  }
`

export const UnknownUserForm = styled.form`
  align-items: center;
  display: flex;
  flex-direction: column;

  ${plume.styles.copy.M} {
    margin: 0 0 11px;
  }

  ${plume.TextField} {
    margin: 0px 0 30px;
    width: 100%;

    &::placeholder {
      color: transparent;
    }
  }

  ${plume.Button} {
    margin: 0 0 10px;
    width: 100%;
  }

  ${plume.styles.copy.XS} {
    color: ${plume.COLORS.GREY_SHADE_3};
    text-transform: uppercase;
    margin: 10px 0 20px;
  }

  ${plume.SocialButton}+${plume.SocialButton} {
    margin-top: 20px;
  }
`

export const Wrapper = styled.div<{ compactMode: boolean }>`
  ${({ compactMode }) => {
    if (compactMode) {
      return css`
        ${plume.TextField} label {
          display: none;
        }

        ${plume.Link} {
          margin: 0;
        }

        // UnknownUserForm
        ${UnknownUserForm} {
          ${plume.TextField} {
            margin: 0 0 8px;
            width: 100%;
          }

          @media screen and ${plume.BREAKPOINTS.LAPTOP} {
            align-items: flex-start;
            flex-direction: row;
            justify-content: space-between;

            ${plume.styles.copy.M} {
              margin: 0;
            }

            ${plume.TextField} {
              margin: 0;
              margin-right: 16px;
            }

            ${plume.Button} {
              margin: 0;
              width: 471px;
            }
          }
        }

        // Existing User
        ${ExistingUserForm} {
          ${plume.Button} {
            display: none;
          }

          ${ExistingUserFormFields} {
            width: 100%;

            ${plume.Button} {
              display: block;
            }
          }

          @media screen and ${plume.BREAKPOINTS.LAPTOP} {
            ${plume.TextField} {
              width: calc(50% - 7px);
              margin-right: 7px;
            }

            ${ExistingUserFormFields} {
              display: flex;
              justify-content: space-between;
              width: 100%;
            }

            ${plume.Button} {
              width: 59%;
              margin-left: 10px;
            }

            ${ExistingUserFormBlock} {
              width: 100%;

              ${plume.CheckboxField} {
                margin-bottom: 0;
              }
            }

            ${plume.Link} {
              ${plume.styles.copy._smallStyle}
              color: ${plume.COLORS.GREY_SHADE_2}; // HACK: Irregular font manipulation
            }
          }
        }
      `
    }
  }}
`
